import { render, staticRenderFns } from "./SurveyQuestionViewerParentCounselWeek.vue?vue&type=template&id=343fefdc&scoped=true"
import script from "./SurveyQuestionViewerParentCounselWeek.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionViewerParentCounselWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fefdc",
  null
  
)

export default component.exports